module.exports = __webpack_public_path__ + "static/media/credit-cards.90934a3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/credit-cards.png
// module id = 65
// module chunks = 1